import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import marketenglishtranslation from './utils/translations/markets/en.json';
import marketspanishtranslation from './utils/translations/markets/es.json';
import marketportugesetranslation from './utils/translations/markets/pt_BR.json';
import englishtranslation from './utils/translations/en.json';
import spanishtranslation from './utils/translations/es.json';
import catalantranslation from './utils/translations/ca.json';
import portugesetranslation from './utils/translations/pt_BR.json';
import mexicantranslation from './utils/translations/es_MX.json';

const resources = {
  en: {
    translation: englishtranslation,
    markets: marketenglishtranslation,
    original: marketenglishtranslation,
  },
  es: {
    translation: spanishtranslation,
    markets: marketspanishtranslation,
    original: marketenglishtranslation,
  },
  'es-MX': {
    translation: mexicantranslation,
    markets: marketspanishtranslation,
    original: marketenglishtranslation,
  },
  ca: {
    translation: catalantranslation,
    markets: marketspanishtranslation,
    original: marketenglishtranslation,
  },
  pt: {
    translation: portugesetranslation,
    markets: marketportugesetranslation,
    original: marketenglishtranslation,
  },
  'pt-BR': {
    translation: portugesetranslation,
    markets: marketportugesetranslation,
    original: marketenglishtranslation,
  },
};

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    ns: ['translation', 'markets', 'original'],
    defaultNS: 'translation',
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
